module.exports = __webpack_public_path__ + "img/room18.616b11e1.gif";